import axios from 'axios'
import {Message,Loading} from 'element-ui'
import {saveAs} from 'file-saver'
import {getToken} from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import {blobValidate} from "@/utils/ruoyi";

const baseURL = process.env.VUE_APP_BASE_API

export default {
  post(url, paramData) {
    const loading = Loading.service({lock: true, text: '处理中', spinner: 'el-icon-loading'});
    const postUrl = baseURL + url
    axios({
      method: 'post',
      url: postUrl,
      data: paramData,
      responseType: 'blob',
      headers: {'Authorization': 'Bearer ' + getToken(), 'Terminal-Type': 'PC'}
    }).then(async (res) => {
      const isBlob = await blobValidate(res.data);
      if (isBlob) {
        const blob = new Blob([res.data])
        this.saveAs(blob, decodeURI(res.headers['filename']))
      } else {
        await this.printErrMsg(res.data);
      }
    }).finally(() => loading.close())
  },
  name(name, isDelete = true) {
    var url = baseURL + "/common/download?fileName=" + encodeURI(name) + "&delete=" + isDelete
    axios({
      method: 'get',
      url: url,
      responseType: 'blob',
      headers: {'Authorization': 'Bearer ' + getToken(), 'Terminal-Type': 'PC'}
    }).then(async (res) => {
      const isBlob = await blobValidate(res.data);
      if (isBlob) {
        const blob = new Blob([res.data])
        this.saveAs(blob, decodeURI(res.headers['download-filename']))
      } else {
        this.printErrMsg(res.data);
      }
    })
  },
  resource(resource) {
    var url = baseURL + "/common/download/resource?resource=" + encodeURI(resource);
    axios({
      method: 'get',
      url: url,
      responseType: 'blob',
      headers: {'Authorization': 'Bearer ' + getToken(), 'Terminal-Type': 'PC'}
    }).then(async (res) => {
      const isBlob = await blobValidate(res.data);
      if (isBlob) {
        const blob = new Blob([res.data])
        this.saveAs(blob, decodeURI(res.headers['download-filename']))
      } else {
        this.printErrMsg(res.data);
      }
    })
  },
  zip(url, name) {
    var url = baseURL + url
    axios({
      method: 'get',
      url: url,
      responseType: 'blob',
      headers: {'Authorization': 'Bearer ' + getToken(), 'Terminal-Type': 'PC'}
    }).then(async (res) => {
      const isBlob = await blobValidate(res.data);
      if (isBlob) {
        const blob = new Blob([res.data], {type: 'application/zip'})
        this.saveAs(blob, name)
      } else {
        this.printErrMsg(res.data);
      }
    })
  },
  saveAs(text, name, opts) {
    saveAs(text, name, opts);
  },
  async printErrMsg(data) {
    const resText = await data.text();
    const rspObj = JSON.parse(resText);
    const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
    Message.error(errMsg);
  }
}
